import React from "react";
import { enUS as enLocale } from "date-fns/locale";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import I24Clock from "assets/icons/I24Clock";
import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";

type Props = {
  label?: string;
  required?: boolean;
  value?: Date;
  invalidDateMessage?: string;
  placeholder?: string;
  error?: string;
  onChange: (date: Date | null) => void;
};

const TimePickerComponent = (props: Props) => {
  const error = Boolean(props.error);

  const helperText = error ? props.error : undefined;

  const convertedProps =
    !error && !helperText
      ? {
          label: props.label,
          required: props.required,
          invalidDateMessage: props.invalidDateMessage,
          placeholder: props.placeholder,
          onChange: props.onChange,
        }
      : {
          label: props.label,
          required: props.required,
          invalidDateMessage: props.invalidDateMessage,
          placeholder: props.placeholder,
          onChange: props.onChange,
          helperText,
          error,
        };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={{
        ...enLocale,
        options: { ...enLocale.options, weekStartsOn: 1 },
      }}
    >
      <TimePicker
        value={props.value ? new Date(props.value) : null}
        format="hh:mm a"
        slots={{
          openPickerIcon: I24Clock,
        }}
        slotProps={{
          textField: {
            variant: "outlined",
            fullWidth: true,
            InputLabelProps: {
              shrink: true,
            },
          },
        }}
        {...convertedProps}
      />
    </LocalizationProvider>
  );
};

export default TimePickerComponent;
